
import WebMap from '@arcgis/core/WebMap';
import { createArcGISGraphics } from './createGraphics';
import MapView from '@arcgis/core/views/MapView';
import { MapProps } from './MapProps';
import { useEffect } from 'react';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { createMyOwnFeaturesInLayersV2 } from '../Calculation/hooks/createMyOwnFeaturesInLayers';
import { IsGridElementFunction } from '../Calculation/hooks/useIsGridElementType';
import { useAppState } from '@/overmind';
import useFeatureToggles from '@/common/hooks/feature-toggles';

export function useAddCalculationSetExecutionResultsToMap(view: MapView | null, props: MapProps, map: WebMap, isGridElementType: IsGridElementFunction) {
  const calculationContext = useAppState().calculation.calculationContext
  const { shouldUseInitiatingObjectHighlighting } = useFeatureToggles();
  const useInitiatingObjectHighlighting = shouldUseInitiatingObjectHighlighting();
  useEffect(() => {
    if(calculationContext.type === "NOT_AVAILABLE")
      return;
    if (!view || !props.featuresInLayers || !map)
      return;

    hideGridNotTakingPartInCalculations();

    const featuresInLayers = createMyOwnFeaturesInLayersV2(
      props.featuresInLayers, props.highlightedFeatures, props.startingPoint);
    const graphics = featuresInLayers
      .map(featuresInLayer => 
        createArcGISGraphics(
          calculationContext.calculationContext.relatedObjectId,
          featuresInLayer.layer.features,
          props.startingPoint,
          props.highlightedFeatures,
          isGridElementType,
          useInitiatingObjectHighlighting
        )
      )
    .flatMap(graphics => graphics);

    const calculationSetExecutionResultsLayer = new GraphicsLayer({
      graphics
    })
    map.add(calculationSetExecutionResultsLayer);
  }, [props.featuresInLayers, props.highlightedFeatures, view, map, calculationContext]);

  function hideGridNotTakingPartInCalculations() {
    map.layers.removeAll();
  }
}
